<template>
  <div class="padding">
    <h3 v-if="showTitle" class="mb-4 mt-0">
      Kortingsdetails
    </h3>
  
    <div v-if="!removeFlex" class="d-flex">
      <FormInput
        class="sm form-element"
        v-model="$v.name.$model"
        :ske="true"
        :vuelidate="$v"
        :focus="true"
        fieldName="name"

        id="name"
        label="Naam"
      />
      <FormSelect
        class="sm form-element middle"
        v-model="$v.type.$model"
        :ske="true"
        :vuelidate="$v"
        :options="typeOptions"
        fieldName="type"

        id="type"
        label="Type"
      />
      <FormInput
        class="sm form-element"
        v-model="$v.minimum_price.$model"
        :ske="true"
        :vuelidate="$v"
        :focus="true"
        fieldName="minimum_price"

        id="minimum_price"
        label="Minimum prijs"
      />
    </div>
    <template v-else>
      <FormInput
        class="sm form-element"
        v-model="$v.name.$model"
        :ske="true"
        :vuelidate="$v"
        :focus="true"
        fieldName="name"

        id="name"
        label="Naam"
      />
      <FormSelect
        class="sm form-element"
        v-model="$v.type.$model"
        :ske="true"
        :vuelidate="$v"
        :options="typeOptions"
        fieldName="type"

        id="type"
        label="Type"
      />
      <FormInput
        class="sm form-element"
        v-model="$v.minimum_price.$model"
        :ske="true"
        :vuelidate="$v"
        :focus="true"
        fieldName="minimum_price"

        id="minimum_price"
        label="Minimum prijs"
      />
    </template>
    <div v-if="!removeFlex" class="d-flex">
      <FormInput
        class="sm form-element"
        v-model="$v.discount_value.$model"
        :ske="true"
        :vuelidate="$v"
        fieldName="discount_value"

        id="discount_value"
        label="Waarde"
      />
      <FormInput
        class="sm form-element"
        v-model="$v.couponCode.$model"
        :ske="true"
        :vuelidate="$v"
        fieldName="couponCode"

        id="couponCode"
        label="Coupon code"
      />
    </div>
    <template v-else>
      <FormInput
        class="sm form-element"
        v-model="$v.discount_value.$model"
        :ske="true"
        :vuelidate="$v"
        fieldName="discount_value"

        id="discount_value"
        label="Waarde"
      />
      <FormInput
        class="sm form-element"
        v-model="$v.couponCode.$model"
        :ske="true"
        :vuelidate="$v"
        fieldName="couponCode"

        id="couponCode"
        label="Coupon code"
      />
    </template>
    <div v-if="!removeFlex" class="d-flex">
      <FormDatePicker
        class="sm form-element"
        v-model="$v.startDate.$model"
        :ske="true"
        :vuelidate="$v"
        fieldName="startDate"

        id="startDate"
        label="Begin datum"
      />
      <FormDatePicker
        class="sm form-element"
        v-model="$v.endDate.$model"
        :ske="true"
        :vuelidate="$v"
        fieldName="endDate"

        id="endDate"
        label="Einddatum"
      />
    </div>
    <template v-else>
      <FormDatePicker
        class="sm form-element"
        v-model="$v.startDate.$model"
        :ske="true"
        :vuelidate="$v"
        fieldName="startDate"

        id="startDate"
        label="Begin datum"
      />
      <FormDatePicker
        :class="{'sm form-element': !removeFlex}"
        v-model="$v.endDate.$model"
        :ske="true"
        :vuelidate="$v"
        fieldName="endDate"

        id="endDate"
        label="Einddatum"
      />
    </template>
  </div>
</template>

<script>

import FormInput from "../../../../components/Inputs/FormInput.vue"
import FormSelect from "../../../../components/Inputs/FormSelect.vue"
import FormDatePicker from "../../../../components/Inputs/FormDatePicker.vue"

import setupForm from "../../../../mixins/setupForm"
import { required } from "vuelidate/lib/validators"

const decimal = value => (value + "").replace(/,/, ".").match(/^[-]?\d*(\.\d+)?$/) ? true : false

const fields = ["name", "discount_value", "startDate", "endDate", "type", "couponCode", "minimum_price"]

export default setupForm(fields, {
  components: {
    FormDatePicker,
    FormInput,
    FormSelect,
  },
  props: {
    removeFlex: Boolean,
    showTitle: Boolean,
  },
  validations: {
    name: {
      required,
    },
    discount_value: {
      required,
      decimal,
    },
    startDate: {
      required,
    },
    endDate: {
      required,
    },
  },
  computed: {
    typeOptions() {
      return [
        {
          value: "price",
          str: "Kortingsprijs product",
        },
        {
          value: "percentage",
          str: "Kortingspercentage product",
        },
        {
          value: "price_cart",
          str: "Kortingsprijs winkelwagen",
        },
        {
          value: "percentage_cart",
          str: "Kortingspercentage winkelwagen",
        },
      ]
    },
  },
})

</script>

<style scoped src="@/assets/css/form.css"></style>
